import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import { Facebook, Twitter, LinkedIn, Instagram } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        py: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={3} md={2}>
            <Typography
              variant="subtitle1"
              sx={{ color: 'text.secondary', fontWeight: 'bold', marginBottom:1}}
            >
              Company
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                href="https://infapp.biz/contact"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'text.primary',
                  '&:hover': { color: 'custom.accentPurple' },
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                }}
              >
                Contact Us
              </Link>
              <Link
                component={RouterLink}
                to="/employee-login"
                sx={{
                  color: 'text.primary',
                  '&:hover': { color: 'custom.accentPurple' },
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                }}
              >
                Employee Login
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} sm={3} md={2}>
            <Typography
              variant="subtitle1"
              sx={{ color: 'text.secondary', fontWeight: 'bold',marginBottom:1 }}
            >
              Support
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                href="/help-faq"
                sx={{
                  color: 'text.primary',
                  '&:hover': { color: 'custom.accentPurple' },
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                }}
              >
                Help / FAQ
              </Link>
              <Link
                href="/how-it-works"
                sx={{
                  color: 'text.primary',
                  '&:hover': { color: 'custom.accentPurple' },
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                }}
              >
                How It Works
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} sm={3} md={2}>
            <Typography
              variant="subtitle1"
              sx={{ color: 'text.secondary', fontWeight: 'bold' ,marginBottom:1}}
            >
              Legal
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                href="/privacy-policy"
                sx={{
                  color: 'text.primary',
                  '&:hover': { color: 'custom.accentPurple' },
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                }}
              >
                Privacy Policy
              </Link>
              <Link
                href="/terms-conditions"
                sx={{
                  color: 'text.primary',
                  '&:hover': { color: 'custom.accentPurple' },
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                }}
              >
                Terms & Conditions
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} sm={3} md={6}>
            <Typography
              variant="subtitle1"
              sx={{ color: 'text.secondary', fontWeight: 'bold' }}
            >
              About Platterly
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'text.primary', maxWidth: 400 }}
            >
              Smart QR-based ordering made simple. Platterly streamlines your dining experience with fast, contactless ordering at your fingertips.
            </Typography>
          </Grid>
        </Grid>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.primary' }}>
              Email:{' '}
              <Link
                href="mailto:admin@infapp.biz"
                sx={{
                  color: 'text.primary',
                  '&:hover': { color: 'custom.accentPurple' },
                  textDecoration: 'none',
                }}
              >
                admin@infapp.biz
              </Link>
            </Typography>
          
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              href="https://facebook.com"
              target="_blank"
              sx={{ color: 'text.primary', '&:hover': { color: 'custom.accentTeal' } }}
            >
              <Facebook fontSize="small" />
            </IconButton>
            <IconButton
              href="https://twitter.com"
              target="_blank"
              sx={{ color: 'text.primary', '&:hover': { color: 'custom.accentTeal' } }}
            >
              <Twitter fontSize="small" />
            </IconButton>
            <IconButton
              href="https://linkedin.com"
              target="_blank"
              sx={{ color: 'text.primary', '&:hover': { color: 'custom.accentTeal' } }}
            >
              <LinkedIn fontSize="small" />
            </IconButton>
            <IconButton
              href="https://instagram.com"
              target="_blank"
              sx={{ color: 'text.primary', '&:hover': { color: 'custom.accentTeal' } }}
            >
              <Instagram fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            margin:2
          }}
        >
        <Typography variant="body2" sx={{ color: 'text.primary' }}>
            © 2026 Platterly. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;